import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import sapphireImage from '../assets/Images/139.jpg';
import rubyImage from '../assets/Images/140.jpg';
import topazImage from '../assets/Images/141.jpg';
import amethystImage from '../assets/Images/142.jpg';
import preciousStonesHeroImage from '../assets/ourproducts/pexels-martabranco-1395306.jpg';

// Logos
import logo1 from '../assets/Images/20.jpeg';
import logo2 from '../assets/Images/28.jpeg';
import logo3 from '../assets/Images/32.jpeg';
import logo4 from '../assets/Images/40.jpeg';
import logo5 from '../assets/Images/65.jpeg';
import logo6 from '../assets/Images/68.jpeg';
import logo7 from '../assets/Images/36.jpeg';
import logo8 from '../assets/Images/26.jpeg';
import logo9 from '../assets/Images/12.jpeg';
import logo10 from '../assets/Images/2.jpeg';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

// Animation variants (unchanged)
const textVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
};

const slideLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
};

const scaleUp = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: 'easeOut' } },
};

const staggerContainer = {
    hidden: { opacity: 1 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.2,
        },
    },
};

const accordionItem = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
};

const PreciousStones = () => {
    const { t } = useTranslation('preciousstones');

    const [activeIndex, setActiveIndex] = useState(0);

    const stones = [
        {
            title: t('stones.sapphire.title'),
            des: t('stones.sapphire.desc'),
            image: sapphireImage,
        },
        {
            title: t('stones.ruby.title'),
            des: t('stones.ruby.desc'),
            image: rubyImage,
        },
        {
            title: t('stones.topaz.title'),
            des: t('stones.topaz.desc'),
            image: topazImage,
        },
        {
            title: t('stones.amethyst.title'),
            des: t('stones.amethyst.desc'),
            image: amethystImage,
        },
    ];

    const navButtons = [
        { title: t('nav.gold'), link: '/gold-jewellery', isActive: false },
        { title: t('nav.silver'), link: '/silver-jewellery', isActive: false },
        { title: t('nav.precious'), link: '/precious-stones', isActive: true },
        { title: t('nav.semiPrecious'), link: '/semi-precious-stones', isActive: false },
    ];

    const logos = [
        logo1, logo2, logo3, logo4, logo5,
        logo6, logo7, logo8, logo9, logo10,
    ];

    const logoSliderSettings = {
        dots: false,
        infinite: true,
        speed: 5000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        arrows: false,
        pauseOnHover: false,
        variableWidth: true,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4 } },
            { breakpoint: 768, settings: { slidesToShow: 3 } },
        ],
    };

    const smLogoSliderSettings = {
        dots: false,
        infinite: true,
        speed: 3000,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: "linear",
        arrows: false,
        pauseOnHover: false,
        variableWidth: true,
    };

    const toggleStone = (index) => {
        setActiveIndex(index);
    };

    return (
        <div className="min-h-screen bg-gray-100">
            {/* Hero Section */}
            <div className="relative flex h-[80vh] w-full items-center justify-center font-lato lg:h-screen">
                <img
                    src={preciousStonesHeroImage}
                    alt={t('hero.alt')}
                    className="absolute inset-0 h-full w-full object-cover"
                />
                <div className="absolute inset-0 bg-black/60" />

                <div className="container relative z-10 flex items-center justify-center pt-[100px]">
                    <div className="w-[90%] text-center md:w-[75%]">
                        <motion.h1
                            variants={textVariants}
                            initial="hidden"
                            animate="visible"
                            className="text-[45px] font-semibold leading-[60px] text-white md:text-[55px] md:leading-[80px] lg:text-[70px] font-copperplate"
                        >
                            {t('hero.title')}
                        </motion.h1>
                        <motion.div
                            variants={textVariants}
                            initial="hidden"
                            animate="visible"
                            className="my-5 text-[18px] font-medium leading-6 md:text-[20px] lg:text-[25px] lg:leading-8"
                        >
                            <span className="text-[#BF943A]">
                                {t('hero.subtitle.highlight')}
                            </span>
                            <span className="text-white">
                                {' '}{t('hero.subtitle.part2')}
                            </span>
                        </motion.div>

                        <motion.div
                            variants={slideLeft}
                            initial="hidden"
                            animate="visible"
                            className="mt-10 flex justify-center gap-4"
                        >
                            <a
                                href="/our-products"
                                className="w-[180px] rounded-full bg-white py-2 text-[14px] font-bold text-black md:text-[16px] lg:text-[18px]"
                            >
                                {t('hero.buttons.categories')}
                            </a>
                            <a
                                href="/contact-us"
                                className="w-[180px] rounded-full bg-[#BF943A] py-2 text-[14px] font-bold text-black md:text-[16px] lg:text-[18px]"
                            >
                                {t('hero.buttons.shopNow')}
                            </a>
                        </motion.div>

                        {/* decorative svgs */}
                    </div>
                </div>
            </div>

            {/* Navigation Buttons Section */}
            <section className="bg-[#1F1F1F] py-12">
                <div className="container flex justify-center gap-4 flex-wrap">
                    {navButtons.map((button, index) => (
                        <a
                            key={index}
                            href={button.link}
                            className={`px-6 py-2 rounded-full font-lato text-[16px] font-semibold transition-all duration-300 ${button.isActive
                                ? 'bg-[#BF943A] text-black'
                                : 'bg-white text-black hover:bg-[#BF943A] hover:text-black'
                                }`}
                        >
                            {button.title}
                        </a>
                    ))}
                </div>
            </section>

            {/* Precious Stones Section */}
            <section className="bg-[#1F1F1F] py-12">
                <div className="container font-lato text-white">
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="flex items-center gap-5"
                    >
                        <div className="h-px w-[40px] bg-[#D7D7D7]"></div>
                        <h1 className="text-[25px] font-semibold uppercase md:text-[30px] lg:text-[40px]">
                            {t('stones.title')}
                        </h1>
                    </motion.div>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="mt-2 justify-between lg:flex"
                    >
                        <div className="w-full font-semibold text-[#AEAEAE] lg:w-[50%] lg:text-[18px]">
                            {t('stones.subtitle')}
                        </div>
                    </motion.div>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="my-6 h-px w-full bg-[#D7D7D7] lg:my-12"
                    ></motion.div>

                    <div className="justify-between gap-14 lg:flex">
                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.3 }}
                            variants={scaleUp}
                            className="relative mb-10 h-[400px] w-full lg:mb-0 lg:h-[550px] lg:w-[40%]"
                        >
                            <img
                                src={stones[activeIndex].image}
                                alt={stones[activeIndex].title}
                                className="rounded-lg object-cover h-full w-full"
                            />
                        </motion.div>

                        <motion.div
                            variants={staggerContainer}
                            initial="hidden"
                            whileInView="show"
                            viewport={{ once: true, amount: 0.2 }}
                            className="w-full space-y-4 lg:w-[60%]"
                        >
                            {stones.map((stone, index) => (
                                <motion.div
                                    key={index}
                                    variants={accordionItem}
                                    className="cursor-pointer rounded-lg border border-gray-600 bg-[#1a1a1a] p-4 transition hover:border-white"
                                    onClick={() => toggleStone(index)}
                                >
                                    <h2 className="flex items-center justify-between text-[16px] font-semibold lg:text-[20px]">
                                        {stone.title}
                                        <span className="text-[25px]">
                                            {activeIndex === index ? '−' : '+'}
                                        </span>
                                    </h2>

                                    {activeIndex === index && (
                                        <p className="mt-2 text-[14px] lg:text-[16px]">{stone.des}</p>
                                    )}
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </div>
            </section>

            {/* Logo Sliders */}
            <section className="block sm:hidden w-full py-6 bg-[#1F1F1F] overflow-hidden">
                <div className="max-w-md mx-auto px-2">
                    <Slider {...smLogoSliderSettings}>
                        {logos.map((logo, index) => (
                            <div key={index} className="flex justify-center px-2">
                                <div className="w-[120px] h-[120px] flex items-center justify-center rounded-lg bg-white/5 p-2">
                                    <img src={logo} alt={`Logo ${index + 1}`} className="max-w-full max-h-full object-contain" loading="lazy" />
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>

            <section className="hidden sm:block w-full py-10 bg-[#1F1F1F] overflow-hidden">
                <div className="max-w-7xl mx-auto px-4">
                    <Slider {...logoSliderSettings}>
                        {logos.map((logo, index) => (
                            <div key={index} className="flex justify-center px-4">
                                <div className="relative w-[200px] h-[200px] flex items-center justify-center rounded-lg">
                                    <img src={logo} alt={`Logo ${index + 1}`} className="object-contain p-2" loading="lazy" />
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>
        </div>
    );
};

export default PreciousStones;